import React from 'react';

import SetStudyPhaseDropdown from 'studies/workspace/overview/SetStudyPhaseDropdown';
import {ButtonSize} from 'ui-library/buttons/Button';

import {StudyOverviewTabContentsProps} from '../utils/TypedStudyTypes';
import AddExperimentButton from '../utils/ui/AddExperimentButton';
import StudyExecutionHeader from './StudyExecutionHeader';

export default function MultiExperimentOverviewTabContents(
  props: StudyOverviewTabContentsProps
): JSX.Element {
  return (
    <StudyExecutionHeader
      {...props}
      executionContainerStyling={executionContainer}
      headerSectionContainerStyling={headerSectionContainerStyling}
      headerButtons={{
        buttons: (
          <>
            <SetStudyPhaseDropdown
              study={{
                id: props.study.id,
                phase: props.study.phase,
                studyType: props.study.studySchema.studyType,
              }}
              refetch={props.refetch}
              isDisabled={!props.isEditable}
              requiresApproval={props.isDesignApprovalRequiredToProceed}
              buttonSize={ButtonSize.MEDIUM}
              allowReturnToDesignPhase={props.allowReturnToDesignPhase}
            />
            <AddExperimentButton studyId={props.study.id} studyType={props.study.studySchema.studyType} />
          </>
        ),
        buttonsStyling: buttonStyling,
      }}
    />
  );
}

const executionContainer: React.CSSProperties = {
  flex: '1 0',
};

const buttonStyling: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 18,
};

const headerSectionContainerStyling: React.CSSProperties = {
  margin: '0 16px',
};
